const constants = {
  TEXT_EDITOR_VERSION: '2.28.2',
  ALT_AVATAR_URL:
    'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80',
};

export default constants;
